<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';
import Banner from 'dashboard/components/ui/Banner.vue';

const { t } = useI18n();
const router = useRouter();
const { isAdmin } = useAdmin();
const { accountId, currentAccount } = useAccount();
const isOnChatwootCloud = useMapGetter('globalConfig/isOnChatwootCloud');

const trial = computed(() => currentAccount.value?.trial);
const access = computed(() => currentAccount.value?.access);
const isActive = computed(
  () =>
    trial.value?.status === 'active' && access.value?.reason === 'trial_active'
);
const isExpired = computed(
  () =>
    trial.value?.status === 'expired' &&
    access.value?.mode === 'read_only' &&
    access.value?.reason === 'trial_expired'
);
const shouldShow = computed(() => {
  if (!isOnChatwootCloud.value || !trial.value) return false;
  return (
    isExpired.value ||
    (isActive.value &&
      (trial.value.notice_days || []).includes(
        Number(trial.value.days_remaining)
      ))
  );
});
const bannerMessage = computed(() => {
  if (isExpired.value) {
    return isAdmin.value
      ? t('BILLING_SETTINGS.TRIAL_BANNER.EXPIRED_ADMIN')
      : t('BILLING_SETTINGS.TRIAL_BANNER.EXPIRED_AGENT');
  }

  if (Number(trial.value.days_remaining) === 1) {
    return t('BILLING_SETTINGS.TRIAL_BANNER.REMAINING_ONE');
  }
  return t('BILLING_SETTINGS.TRIAL_BANNER.REMAINING', {
    days: trial.value.days_remaining,
  });
});

const routeToBilling = () => {
  router.push({
    name: 'billing_settings_index',
    params: { accountId: accountId.value },
  });
};
</script>

<template>
  <div class="contents">
    <Banner
      v-if="shouldShow"
      :color-scheme="isExpired ? 'alert' : 'warning'"
      :banner-message="bannerMessage"
      :action-button-label="$t('BILLING_SETTINGS.TRIAL_BANNER.ACTION')"
      :has-action-button="isAdmin"
      @primary-action="routeToBilling"
    />
  </div>
</template>
